module.exports = __webpack_public_path__ + "static/media/ten-ball.1f9ccc1b.png";